// تعريب سجل التدقيق — على مستوى العرض فقط.
//
// البيانات المحفوظة لا تُمسّ: `action` و`module` و`severity` تبقى مفاتيح
// إنجليزية في قاعدة البيانات (الفهارس والترشيح والسجلات القديمة تعتمد عليها،
// والمسار /api/audit يرشّح بمطابقة تامة على المفتاح). الترجمة تحدث هنا لحظة
// العرض، فتُعرَّب السجلات القديمة والجديدة معاً بلا أي ترحيل.
//
// كيف جُمعت المفاتيح: مسح لكل مواضع الكتابة في الخادم —
//   grep -rE "action: '[^']+'"  backend/src          → 96 مفتاحاً
//   grep -rn "auditLog({"       backend/src          → وسيط المسارات العام
//                                                      (create/update/delete/photo)
//   grep -rnE "action: \`|action: [a-zA-Z_]" backend/src → 5 مفاتيح تُبنى شرطياً
//     (card.delete / card.deactivate / deny /
//      pos.checkout.settle_group / pos.checkout.settle_session)
// الإجمالي: 105 مفاتيح إجراء (كل ما يكتبه الخادم فعلاً) + 22 وحدة
// + 4 درجات خطورة. الفحص المقابل: كل مفتاح في الخادم له ترجمة، ولا ترجمة
// لمفتاح غير موجود.

// ───── الوحدات ────────────────────────────────────────────────────────
export const MODULE_LABELS = {
  auth: 'الأمان والدخول',
  cards: 'البطاقات',
  cashbox: 'القاصات',
  'catalog.categories': 'تصنيفات المنتجات',
  'catalog.products': 'المنتجات',
  'catalog.suppliers': 'المورّدون',
  'catalog.warehouses': 'المخازن',
  children: 'الأطفال',
  debts: 'الديون',
  devices: 'الأجهزة',
  settings: 'الإعدادات',
  finance: 'المالية',
  gates: 'البوابات',
  guardians: 'أولياء الأمور',
  pos: 'نقطة البيع',
  pricing: 'التسعير',
  purchases: 'المشتريات',
  roles: 'الأدوار والصلاحيات',
  sessions: 'الجلسات',
  shifts: 'الشفتات',
  subscriptions: 'الاشتراكات',
  system: 'النظام',
  users: 'المستخدمون'
};

// ───── الإجراءات ──────────────────────────────────────────────────────
export const ACTION_LABELS = {
  // الإعدادات
  'print_logo.upload': 'رفع شعار الطباعة',
  'print_logo.delete': 'حذف شعار الطباعة',

  // الأمان والدخول
  'auth.login.success': 'تسجيل دخول ناجح',
  'auth.login.failure': 'محاولة دخول فاشلة',
  'auth.logout': 'تسجيل خروج',
  'auth.password.change': 'تغيير كلمة المرور',

  // البطاقات
  'card.create': 'إنشاء بطاقة',
  'card.bulk_create': 'إنشاء بطاقات بالدفعة',
  'card.update': 'تعديل بطاقة',
  'card.delete': 'حذف بطاقة',
  'card.deactivate': 'تعطيل بطاقة',
  'card.block': 'حظر بطاقة',
  'card.release': 'تحرير بطاقة',
  'card.topup': 'تعبئة رصيد بطاقة',

  // القاصات
  'cashbox.create': 'إنشاء قاصة',
  'cashbox.update': 'تعديل قاصة',
  'cashbox.delete': 'حذف قاصة',
  'cashbox.adjust': 'تسوية رصيد قاصة',
  'cashbox.opening_entry': 'إدخال رصيد افتتاحي',
  'cashbox.transfer': 'تحويل بين القاصات',

  // تصنيفات المنتجات
  'category.create': 'إنشاء تصنيف',
  'category.update': 'تعديل تصنيف',
  'category.delete': 'حذف تصنيف',

  // الأجهزة
  'device.create': 'إضافة جهاز',
  'device.update': 'تعديل جهاز',
  'device.delete': 'حذف جهاز',

  // المالية — المصاريف
  'expense.create': 'تسجيل مصروف',
  'expense.update': 'تعديل مصروف',
  'expense.cancel': 'إلغاء مصروف',
  'expense_category.create': 'إنشاء تصنيف مصاريف',
  'expense_category.update': 'تعديل تصنيف مصاريف',
  'expense_category.delete': 'حذف تصنيف مصاريف',

  // المالية — الإيرادات
  'revenue.create': 'تسجيل إيراد',
  'revenue_category.create': 'إنشاء تصنيف إيرادات',
  'revenue_category.update': 'تعديل تصنيف إيرادات',
  'revenue_category.delete': 'حذف تصنيف إيرادات',

  // البوابات
  'gate.create': 'إضافة بوابة',
  'gate.update': 'تعديل بوابة',
  'gate.delete': 'حذف بوابة',
  'gate.event': 'حدث بوابة',
  'gate.manual_override': 'فتح البوابة يدوياً',
  'gate.simulate': 'محاكاة بوابة',
  open_gate: 'فتح البوابة',
  deny: 'رفض الدخول من البوابة',

  // المخزون
  'inventory.adjust': 'تسوية مخزون',

  // الديون
  'debts.settle': 'تسديد دين',
  'debts.payment.reverse': 'عكس دفعة دين',

  // الاشتراكات
  'subscription.sell': 'بيع اشتراك',
  'subscription.renew': 'تجديد اشتراك',
  'subscription.cancel': 'إلغاء اشتراك',
  'subscription.plan.create': 'إنشاء خطة اشتراك',
  'subscription.plan.update': 'تعديل خطة اشتراك',
  'subscription.plan.delete': 'حذف خطة اشتراك',

  // نقطة البيع
  'pos.sale.create': 'إنشاء فاتورة بيع',
  'pos.sale.pay': 'تحصيل فاتورة بيع',
  'pos.sale.cancel': 'إلغاء فاتورة بيع',
  'pos.checkout.settle_session': 'محاسبة جلسة',
  'pos.checkout.settle_group': 'محاسبة مجموعة كارت',

  // التسعير
  'pricing.rule.create': 'إنشاء قاعدة تسعير',
  'pricing.rule.update': 'تعديل قاعدة تسعير',
  'pricing.rule.delete': 'حذف قاعدة تسعير',
  'pricing.rule.set_default': 'تعيين قاعدة التسعير الافتراضية',
  'pricing.package.create': 'إنشاء باقة',
  'pricing.package.update': 'تعديل باقة',
  'pricing.package.delete': 'حذف باقة',
  'pricing.discount.create': 'إنشاء خصم',
  'pricing.discount.update': 'تعديل خصم',
  'pricing.discount.delete': 'حذف خصم',

  // المنتجات
  'product.create': 'إضافة منتج',
  'product.update': 'تعديل منتج',
  'product.delete': 'حذف منتج',
  'product.import': 'استيراد منتجات',
  'product.quick_add': 'إضافة منتج سريعة',

  // المشتريات
  'purchase.create': 'إنشاء فاتورة مشتريات',
  'purchase.update': 'تعديل فاتورة مشتريات',
  'purchase.post': 'ترحيل فاتورة مشتريات',
  'purchase.cancel': 'إلغاء فاتورة مشتريات',
  'purchase.delete': 'حذف فاتورة مشتريات',

  // المورّدون
  'supplier.create': 'إضافة مورّد',
  'supplier.update': 'تعديل مورّد',
  'supplier.delete': 'حذف مورّد',

  // المخازن
  'warehouse.create': 'إضافة مخزن',
  'warehouse.update': 'تعديل مخزن',
  'warehouse.delete': 'حذف مخزن',

  // الأدوار
  'roles.create': 'إنشاء دور',
  'roles.update': 'تعديل دور',
  'roles.delete': 'حذف دور',
  'roles.permissions.update': 'تعديل صلاحيات دور',

  // الجلسات
  'session.open': 'فتح جلسة',
  'session.extend': 'تمديد جلسة',
  'session.exit': 'خروج من جلسة',
  'session.cancel': 'إلغاء جلسة',

  // الشفتات
  'shift.open': 'فتح شفت',
  'shift.close': 'إقفال شفت',
  'shift.approve_variance': 'اعتماد فرق الصندوق',

  // النظام
  'system.backup_export': 'تصدير نسخة احتياطية',
  'system.backup_restore': 'استعادة نسخة احتياطية',
  'system.demo_seed': 'زرع بيانات تجريبية',
  'system.reset': 'إعادة ضبط النظام',
  'system.wipe_data': 'محو بيانات النظام',

  // المستخدمون
  'users.create': 'إنشاء مستخدم',
  'users.update': 'تعديل مستخدم',
  'users.delete': 'حذف مستخدم',
  'users.password.reset': 'إعادة ضبط كلمة مرور',
  'users.permissions.set': 'تعيين صلاحيات مستخدم',
  'users.role.change': 'تغيير دور مستخدم',
  'users.status.change': 'تغيير حالة مستخدم'
};

// وسيط المسارات العام يكتب أفعالاً مجرّدة (create/update/delete/photo) ومعها
// الوحدة فقط، فتُقرأ الوحدة لإنتاج عبارة مفهومة بدل «إنشاء» المجرّدة.
const GENERIC_ACTIONS = {
  create: 'إنشاء',
  update: 'تعديل',
  delete: 'حذف',
  photo: 'تحديث الصورة',
  read: 'استعراض',
  view: 'استعراض',
  list: 'استعراض',
  export: 'تصدير',
  import: 'استيراد',
  cancel: 'إلغاء',
  restore: 'استعادة',
  print: 'طباعة'
};

const GENERIC_BY_MODULE = {
  children: {
    create: 'تسجيل طفل جديد',
    update: 'تعديل بيانات طفل',
    delete: 'حذف طفل',
    photo: 'تحديث صورة طفل'
  },
  guardians: {
    create: 'تسجيل ولي أمر',
    update: 'تعديل بيانات ولي أمر',
    delete: 'حذف ولي أمر'
  }
};

// مقاطع تُستعمل لبناء عبارة مفهومة لأي إجراء جديد لم يُترجَم بعد — بدل أن
// يظهر المفتاح الإنجليزي خاماً، وبدل أن تظهر خانة فارغة.
const SEGMENTS = {
  auth: 'الأمان',
  login: 'تسجيل الدخول',
  logout: 'تسجيل الخروج',
  password: 'كلمة المرور',
  success: 'ناجح',
  failure: 'فاشل',
  failed: 'فاشل',
  denied: 'مرفوض',
  change: 'تغيير',
  reset: 'إعادة ضبط',
  set: 'تعيين',
  set_default: 'تعيين كافتراضي',
  card: 'بطاقة',
  cards: 'البطاقات',
  cashbox: 'القاصة',
  category: 'تصنيف',
  categories: 'التصنيفات',
  device: 'جهاز',
  devices: 'الأجهزة',
  expense: 'مصروف',
  expense_category: 'تصنيف مصاريف',
  revenue: 'إيراد',
  revenue_category: 'تصنيف إيرادات',
  gate: 'بوابة',
  gates: 'البوابات',
  inventory: 'المخزون',
  pos: 'نقطة البيع',
  sale: 'فاتورة بيع',
  sales: 'المبيعات',
  checkout: 'المحاسبة',
  settle: 'تسوية',
  settle_session: 'محاسبة جلسة',
  settle_group: 'محاسبة مجموعة',
  pay: 'تحصيل',
  refund: 'إرجاع',
  pricing: 'التسعير',
  rule: 'قاعدة تسعير',
  package: 'باقة',
  discount: 'خصم',
  product: 'منتج',
  products: 'المنتجات',
  purchase: 'فاتورة مشتريات',
  purchases: 'المشتريات',
  post: 'ترحيل',
  supplier: 'مورّد',
  suppliers: 'المورّدون',
  warehouse: 'مخزن',
  warehouses: 'المخازن',
  role: 'دور',
  roles: 'الأدوار',
  permission: 'صلاحية',
  permissions: 'الصلاحيات',
  session: 'جلسة',
  sessions: 'الجلسات',
  open: 'فتح',
  close: 'إقفال',
  exit: 'خروج',
  extend: 'تمديد',
  shift: 'شفت',
  shifts: 'الشفتات',
  variance: 'فرق الصندوق',
  approve: 'اعتماد',
  approve_variance: 'اعتماد فرق الصندوق',
  system: 'النظام',
  backup: 'نسخة احتياطية',
  backup_export: 'تصدير نسخة احتياطية',
  backup_restore: 'استعادة نسخة احتياطية',
  demo_seed: 'زرع بيانات تجريبية',
  wipe_data: 'محو البيانات',
  user: 'مستخدم',
  users: 'المستخدمون',
  child: 'طفل',
  children: 'الأطفال',
  debt: 'دين',
  debts: 'الديون',
  subscription: 'اشتراك',
  subscriptions: 'الاشتراكات',
  plan: 'خطة',
  renew: 'تجديد',
  sell: 'بيع',
  reverse: 'عكس',
  payment: 'دفعة',
  guardian: 'ولي أمر',
  guardians: 'أولياء الأمور',
  status: 'الحالة',
  topup: 'تعبئة رصيد',
  block: 'حظر',
  release: 'تحرير',
  deactivate: 'تعطيل',
  activate: 'تفعيل',
  adjust: 'تسوية',
  transfer: 'تحويل',
  opening_entry: 'رصيد افتتاحي',
  bulk_create: 'إنشاء بالدفعة',
  quick_add: 'إضافة سريعة',
  manual_override: 'تجاوز يدوي',
  simulate: 'محاكاة',
  event: 'حدث',
  photo: 'صورة',
  ...GENERIC_ACTIONS
};

/** اسم الوحدة بالعربية — وإلا المفتاح كما هو، ولا تُعاد خانة فارغة أبداً. */
export function labelForModule(moduleKey) {
  const key = String(moduleKey || '').trim();
  if (!key) return 'غير محدّد';
  return MODULE_LABELS[key] || key;
}

/**
 * اسم الإجراء بالعربية.
 *
 * الترتيب: ترجمة تامة ← فعل عام بحسب الوحدة ← تركيب من مقاطع مترجمة ←
 * المفتاح الخام. لا تُعاد قيمة فارغة في أي حالة.
 */
export function labelForAction(action, moduleKey) {
  const key = String(action || '').trim();
  if (!key) return 'إجراء غير مسمّى';

  if (ACTION_LABELS[key]) return ACTION_LABELS[key];

  const mod = String(moduleKey || '').trim();
  const perModule = GENERIC_BY_MODULE[mod];
  if (perModule && perModule[key]) return perModule[key];

  if (GENERIC_ACTIONS[key]) {
    const modLabel = MODULE_LABELS[mod];
    return modLabel ? `${GENERIC_ACTIONS[key]} — ${modLabel}` : GENERIC_ACTIONS[key];
  }

  // تركيب من المقاطع: نجرّب المقطع كاملاً ثم بالشرطة السفلية.
  const parts = key.split('.').filter(Boolean);
  const translated = parts.map((p) => SEGMENTS[p] || SEGMENTS[p.replace(/-/g, '_')] || null);
  if (translated.some(Boolean)) {
    return translated.map((t, i) => t || parts[i]).join(' · ');
  }

  // لا ترجمة إطلاقاً: المفتاح الخام مقروءاً (لا خانة فارغة).
  return key.replace(/[._]/g, ' ');
}

/** هل الإجراء مترجَم ترجمة تامة (لا تركيباً احتياطياً)؟ */
export function hasActionLabel(action) {
  return Object.prototype.hasOwnProperty.call(ACTION_LABELS, String(action || '').trim());
}

// ───── الخطورة ────────────────────────────────────────────────────────
export const SEVERITY_LABELS = {
  info: 'معلومة',
  warning: 'تحذير',
  danger: 'خطر',
  critical: 'خطر بالغ'
};

export const SEVERITY_VARIANTS = {
  info: 'muted',
  warning: 'warning',
  danger: 'danger',
  critical: 'danger'
};

export function labelForSeverity(severity) {
  const key = String(severity || 'info').trim();
  return SEVERITY_LABELS[key] || key;
}

export function variantForSeverity(severity) {
  return SEVERITY_VARIANTS[String(severity || 'info').trim()] || 'muted';
}

// ───── التاريخ والوقت بصيغة مألوفة عربياً ─────────────────────────────
// صياغة يدوية مقصودة: أسماء الأيام والأشهر بالعربية مع أرقام لاتينية —
// وهو ما يعتمده باقي النظام (shared/format.js) — ودون الاعتماد على توفّر
// بيانات اللغة العربية في Intl داخل متصفّح العميل.
const WEEKDAYS_AR = ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
const MONTHS_AR = [
  'كانون الثاني', 'شباط', 'آذار', 'نيسان', 'أيار', 'حزيران',
  'تموز', 'آب', 'أيلول', 'تشرين الأول', 'تشرين الثاني', 'كانون الأول'
];

function asDate(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

const pad = (n) => String(n).padStart(2, '0');

/** «14 تشرين الأول 2026» */
export function formatAuditDate(value) {
  const d = asDate(value);
  if (!d) return '—';
  return `${d.getDate()} ${MONTHS_AR[d.getMonth()]} ${d.getFullYear()}`;
}

/** «03:25 م» — صباحاً/مساءً بالعلامة العربية المختصرة. */
export function formatAuditTime(value) {
  const d = asDate(value);
  if (!d) return '—';
  const h24 = d.getHours();
  const marker = h24 < 12 ? 'ص' : 'م';
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${pad(h12)}:${pad(d.getMinutes())} ${marker}`;
}

/** «الأربعاء 14 تشرين الأول 2026 — 03:25 م» */
export function formatAuditDateTime(value) {
  const d = asDate(value);
  if (!d) return '—';
  return `${WEEKDAYS_AR[d.getDay()]} ${formatAuditDate(d)} — ${formatAuditTime(d)}`;
}

/** قائمة الإجراءات لقوائم الترشيح — مرتّبة ومجمّعة حسب الوحدة. */
export function actionFilterOptions() {
  const groups = new Map();
  for (const [key, label] of Object.entries(ACTION_LABELS)) {
    // المجموعة = الجزء الأول من المفتاح، ومنها نستنتج وحدة معروفة إن أمكن.
    const head = key.includes('.') ? key.split('.')[0] : 'other';
    const groupLabel = MODULE_LABELS[head] || SEGMENTS[head] || 'إجراءات أخرى';
    if (!groups.has(groupLabel)) groups.set(groupLabel, []);
    groups.get(groupLabel).push({ key, label });
  }
  return [...groups.entries()]
    .map(([group, options]) => ({
      group,
      options: options.sort((a, b) => a.label.localeCompare(b.label, 'ar'))
    }))
    .sort((a, b) => a.group.localeCompare(b.group, 'ar'));
}
